import FilterProto from "./filter-field-proto";
import React from "react";
import FilterFormString from "../../../gd-app/panels/filters-panel/filter-form/string/string";

const debug = {
    dev: false
};

export default class FilterStringProto extends FilterProto {

    constructor(filtersManager, filterConfig, initValue, label) {
        super(filtersManager, filterConfig, initValue, label);
    }

    // used only in Filter component
    getValue() {
        return this.value?this.value:null;
    }

    setValue(val, silent=false) {
        this.isEnabled = true;

        if (!val || (val.trim()=='') ) {
            val = null;
            this.isEnabled = false;
        } else {
            this.isEnabled = true;
        }

        super.setValue(val, silent);
    }

    optionsFillerFunc = false;

    render() {

        return <FilterFormString filter={this} min={0} max={100} />
    }


}